import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './picture-preview.css';
import '../icon/icon.js';
import '../modal/modal.js';
/**
 * @property {string} deviceVariant
 */
export default class PicturePreview extends TemplateElement {
    constructor() {
        super({ styles: [style], shadowRender: true });
    }

    properties() {
        return {
            deviceVariant: '', // 'mobile' || 'desktop' || 'all'
        };
    }

    events() {
        return {
            '[show-modal]': {
                click: () => {
                    this.$refs.modal.show();
                },
            },
        };
    }

    template() {
        return html`
            <div class="picture-container magnify-container" show-modal="${this.id}-modal">
                <slot name="preview"></slot>
                <button class="Button btn btn-primary magnify-btn" type="button" data-variant="${this.deviceVariant}">
                    <mb-icon name="app--zoom-in"></mb-icon>
                </button>
            </div>
            <mb-modal ref="modal" id="${this.id}-modal" placement="fullscreen" close-label="Close">
                <slot name="full"></slot>
            </mb-modal>
        `;
    }
}

defineElement('mb-picture-preview', PicturePreview);
